import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimoniosSection() {
  const testimonials = [{
    quote: 'Me dio estructura real para toda la materia. Ahora planifico en minutos lo que antes me llevaba horas de búsqueda.',
    name: 'Claudia Ramírez',
    role: 'Profesora de Metodología, 42 años'
  }, {
    quote: 'Por primera vez trabajé metodología con claridad. Mis alumnos presentaron proyectos de investigación de nivel preuniversitario.',
    name: 'Martín Herrera',
    role: 'Docente de Ciencias Sociales, 38 años'
  }, {
    quote: 'Elevó el nivel académico del curso. Los 25 proyectos listos son un recurso invaluable para cualquier docente.',
    name: 'Soledad Aguirre',
    role: 'Profesora de Investigación Social, 45 años'
  }, {
    quote: 'El enfoque mixto cuanti-cuali está perfectamente explicado. Mis estudiantes por fin entienden correlación y análisis de datos.',
    name: 'Federico Torres',
    role: 'Docente de Metodología, 35 años'
  }, {
    quote: 'Como estudiante de profesorado en Ciencias Sociales, este kit me adelantó años de experiencia. Lo recomiendo a todos.',
    name: 'Valentina Paz',
    role: 'Estudiante de profesorado, 24 años'
  }];
  return <section id="testimonios" className="py-8 sm:py-16 bg-[#0f172a]" data-id="element-213">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-214">
        <div className="text-center mb-8 sm:mb-12" data-id="element-215">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-216">
            Testimonios de docentes
          </h2>
          <p className="text-gray-400 text-sm sm:text-base" data-id="element-217">
            Lo que dicen quienes ya están usando el kit en sus aulas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-218">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1e293b] p-5 sm:p-6 rounded-xl border border-gray-700 relative hover:border-[#fbbf24]/50 transition-colors" data-id="element-219">
              <Quote className="absolute top-4 right-4 text-gray-600 h-6 w-6 opacity-50" data-id="element-220" />

              <div className="flex gap-1 mb-3" data-id="element-221">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-4 w-4 text-[#fbbf24] fill-current" data-id="element-222" />)}
              </div>

              <p className="text-gray-200 text-sm sm:text-base italic mb-4 leading-relaxed" data-id="element-223">
                "{t.quote}"
              </p>

              <div className="mt-auto" data-id="element-224">
                <p className="text-white font-bold text-sm" data-id="element-225">— {t.name}</p>
                <p className="text-gray-400 text-xs" data-id="element-226">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}